import { HttpContextToken } from '@angular/common/http';

export const SKIP_NAMESPACE_TOKEN = new HttpContextToken<boolean>(() => false);
